import { Account } from 'api/account/types'

export const accounts: Account[] = [
  {
    id: '1',
    gender: 'm',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'radu.pitis@fyber.com',
    country: 'RO',
    payoutCurrency: 'EUR',
    paymentMethod: 'wiretransfer',
    beneficiaryName: 'RaduPitis',
    bankName: 'ING',
    iban: 'IBANNUMBER',
    swiftCode: 'INGROBU',
  },
]
